<style lang="scss">
.button-wrapper {
    cursor: pointer;
}

.play-button {
    height: 80px;
    width: 80px;
    background-color: #FFF;
    border-radius: 50%;
    display: inline-block;
}

.play-button:before {
    position: absolute;
    content: "";
    transform: translateY(-50%);
    margin: 39px 31px;
    background-image: url("/svg/play.svg");
    background-size: contain;
    background-repeat: no-repeat;
    width: 32px;
    height: 32px;
    transition: all 0.3s;
    opacity: 1;
}

.play-button:hover:before {
    height: 36px;
    width: 36px;
}
</style>

<template>
    <div class="button-wrapper">
        <span v-if="videoId != null && videoId != ''" @click="showVideo = !showVideo" class="play-button"></span>
        <portal v-if="arrayKey == 0" to="video-modal-destination-0">
            <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
        </portal>
        <portal v-else-if="arrayKey == 1" to="video-modal-destination-1">
            <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
        </portal>
        <portal v-else to="video-modal-destination">
            <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
        </portal>
    </div>
</template>

<script>
import VideoModal from "./VideoModal";

export default {
    components: {
        VideoModal
    },
    props: {
        videoId: {
            type: String,
            required: true,
        },
        arrayKey: {
            required: false,
        },
    },

    data() {
        return {
            showVideo: false,
        };
    },

    methods: {
        close() {
            this.showVideo = false;
        },
    }
};
</script>
